import { NavParams, ViewController } from "ionic-angular";
import { IAclCategoryModalArgs } from "./acl-category-modal.component";
import { Subject } from "rxjs/Subject";
import { AclCategoryModalModel } from "./acl-category-modal.model";
import { AclCategoryModalItemModel } from "./acl-category-modal-item.model";
import { FormControl, FormGroup } from "@angular/forms";
import { zip } from "rxjs/observable/zip";
import { VasAppFacade } from "../../../services/vas-app-facade.service";
import { BaseController } from "../../../../core/controllers/base.controller";
import { Observable } from "rxjs/Observable";

export interface IAclCategoryModalFilterValues {
    searchTerm?: string;
    accessGroup?: string;
}

export class AclCategoryModalController extends BaseController {

    protected _model$ = new Subject<AclCategoryModalModel>();
    protected _filterFormGroup = new FormGroup({
        searchTerm: new FormControl(""),
        accessGroup: new FormControl("")
    });

    constructor(
        protected appFacade: VasAppFacade,
        protected viewController: ViewController
    ) {

        super();
    }

    ngOnInit(navParams: NavParams): void {

        const params = this.parseNavParams(navParams);

        // wait for the app to be ready
        this.appFacade.whenAppReady()
            // collect the data we need
            .concatMap(() => zip(
                this.appFacade.objects.accessGroup.store.getAll().take(1),
                this.appFacade.objects.membership.store.getActive().take(1),
                this.appFacade.objects.user.store.getAll().take(1)
            ))
            // build the model
            .map(([accessGroups, activeMembership, users]) => {

                return AclCategoryModalModel.getInstance({
                    accessGroups,
                    activeMembership,
                    category: params.categoryType,
                    categoryId: params.categoryId,
                    filterFormGroup: this._filterFormGroup,
                    memberships: params.memberships,
                    users
                });
            })
            .take(1)
            .subscribe(
                model =>  this._model$.next(model),
                error => {
                    this.appFacade.alert.ok("Error", error).then(() => this.dismiss());
                }
            );
    }

    ionViewCanEnter(navParams: NavParams): boolean {

        try {
            this.parseNavParams(navParams);
        } catch (e) {
            console.warn(e);
            return false;
        }
        return true;
    }

    get model$(): Observable<AclCategoryModalModel> {
        return this._model$;
    }

    parseNavParams(navParams): IAclCategoryModalArgs {

        if (!navParams.get("categoryType")) {
            throw new Error("categoryType is undefined");
        }

        if (!navParams.get("categoryId")) {
            throw new Error("categoryType is undefined");
        }

        if (!navParams.get("memberships")) {
            throw new Error("memberships is undefined");
        }

        return {
            categoryType: navParams.get("categoryType"),
            categoryId: navParams.get("categoryId"),
            memberships: navParams.get("memberships")
        };
    }

    grant(model: AclCategoryModalModel, itemModel: AclCategoryModalItemModel): void {

        if (itemModel.value) {
            return;
        }

        this._model$.next(model.grant(itemModel));
    }

    grantAll(model: AclCategoryModalModel): void {
        this._model$.next(model.grantAll());
    }

    revoke(model: AclCategoryModalModel, itemModel: AclCategoryModalItemModel): void {

        if (!itemModel.value) {
            return;
        }

        this._model$.next(model.revoke(itemModel));
    }

    revokeAll(model: AclCategoryModalModel): void {
        this._model$.next(model.revokeAll());
    }

    toggle(model: AclCategoryModalModel, itemModel: AclCategoryModalItemModel): void {

        if (itemModel.value) {
            this.revoke(model, itemModel);
        } else {
            this.grant(model, itemModel);
        }
    }

    submit(model: AclCategoryModalModel): void {
        this.viewController.dismiss(model);
    }

    dismiss(): void {
        this.viewController.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/form/acl-category-modal.controller.ts